import { createApp } from 'vue'
import { createPinia } from 'pinia'

// Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { VDateInput } from 'vuetify/labs/VDateInput'
import { aliases } from 'vuetify/iconsets/mdi-svg'

import '@mdi/font/scss/materialdesignicons.scss'

import App from './App.vue'
import './registerServiceWorker'
import router from './router'

import dayjs from 'dayjs'
import 'dayjs/locale/pt'
import 'dayjs/locale/en'
import LocalizedFormat from 'dayjs/plugin/localizedFormat'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

import i18n from './translations/i18n'
import { useAppStore } from './stores/appStore'
import GoRateDeleteOutline from './components/icons/GoRateDeleteOutline.vue'
import GoRateDuplicate from './components/icons/GoRateDuplicate.vue'
import GoRateEdit from './components/icons/GoRateEdit.vue'
import GoRateAvatar from './components/icons/GoRateAvatar.vue'
import { isAxiosError } from 'axios'

dayjs.extend(LocalizedFormat)
dayjs.extend(isSameOrAfter)
dayjs.extend(isSameOrBefore)
dayjs.extend(timezone)
dayjs.extend(utc)

const customIconAliases = {
  ...aliases,
  GoRateDeleteOutline,
  GoRateDuplicate,
  GoRateEdit,
  GoRateAvatar
}

const vuetify = createVuetify({
  components: {
    ...components,
    VDateInput
  },
  directives,
  icons: {
    defaultSet: 'mdi',
    aliases: {
      ...customIconAliases
    }
  }
})

const pinia = createPinia()

const app = createApp(App)
  .use(pinia)
  .use(router)
  .use(vuetify)
  .use(i18n)

const appStore = useAppStore()

app.config.errorHandler = (error) => {
  console.error('Global error handler: ', error)
  if (isAxiosError(error)) {
    switch (error.response?.status) {
      case 400:
        useAppStore().addAlert('error', error.response?.data.responseMessage)
        break
      case 401:
        useAppStore().addAlert('error', error.response?.data.responseMessage)
        router.push({ name: 'Login' })
        break
      case 404:
        useAppStore().addAlert('error', error.response?.data.responseMessage)
        break
      case 409:
        useAppStore().addAlert('error', error.response?.data.responseMessage)
        break
      default:
        useAppStore().addAlert('error', error.message)
        break
    }
  }
}

app.mount('#app')
